export default "__VITE_ASSET__Bl_MD68k__"